import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/muteHistorys/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/muteHistorys/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/muteHistorys/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/muteHistorys/delete',
    method: 'post',
    data
  })
}

